import { render, staticRenderFns } from "./SimpleBox.vue?vue&type=template&id=129322e6&scoped=true&"
import script from "./SimpleBox.vue?vue&type=script&lang=js&"
export * from "./SimpleBox.vue?vue&type=script&lang=js&"
import style0 from "./SimpleBox.vue?vue&type=style&index=0&id=129322e6&lang=scss&scoped=true&"
import style1 from "./SimpleBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129322e6",
  null
  
)

export default component.exports